import Vue from 'vue';
import Vuex from 'vuex';
// import VuexPersist from 'vuex-persist';
import { log } from "@/utils/func";
import {  isNil } from "lodash";

Vue.use(Vuex);

const keyStorage = 'tlkAbbonamento';

/*
const vuexLocalStorage = new VuexPersist({
  key: keyStorage,
  storage: window.localStorage,
  reducer: (state) => ({
    abbonamento: state.abbonamento,
    step: state.step,
    subscriptions: state.subscriptions,
    variations: state.variations,
    obiettivi: state.obiettivi,
    allergeni: state.allergeni,
    products: state.products
  })
});
*/

export default new Vuex.Store({
  state: {
    abbonamento: {
      id: null,
      subscription: null,
      variation: null,
      obiettivi: [],
      allergeni: [],
      products: []
    },
    step: 0,
    subscriptions: [],
    variations: [],
    obiettivi: [],
    allergeni: [],
    products: null,
    backupProductsSelected: []
  },
  mutations: {
    setStep(state, data) {
      state.step = data;
    },
    setSubscriptions(state, data) {
      state.subscriptions = data;
    },
    setVariations(state, data) {
      state.variations = data;
    },
    setObiettivi(state, data) {
      state.obiettivi = data;
    },
    setAllergeni(state, data) {
      state.allergeni = data;
    },
    setProducts(state, data) {
      state.products = data;
    },
    setBackupProductsSelected(state, data) {
      state.backupProductsSelected = data;
    },
    setStore(state, data) {
      if (!isNil(data.id)) state.abbonamento.id = data.id;
      if (!isNil(data.subscription)) state.abbonamento.subscription = data.subscription;
      if (!isNil(data.variation)) state.abbonamento.variation = data.variation;
      if (!isNil(data.obiettivi)) state.abbonamento.obiettivi = data.obiettivi;
      if (!isNil(data.allergeni)) state.abbonamento.allergeni = data.allergeni;
      if (!isNil(data.products)) state.abbonamento.products = data.products;
    },
    destroy() {
      if (localStorage.getItem(keyStorage)) {
        localStorage.removeItem(keyStorage);
        log('destroy store', localStorage);
      }
    }
  },
  actions: {
    init(context) {
      log('initAbbonamento');
      context.commit('destroy');
    },
    close(context) {
      const abbonamento = {
        id: null,
        subscription: null,
        variation: null,
        obiettivi: [],
        allergeni: [],
        products: []
      };

      log('closeAbbonamento', abbonamento);
      context.commit('setStep', 6);
      context.commit('setStore', abbonamento);
      context.commit('destroy');
    },
    reset(context) {
      const abbonamento = {
        id: null,
        subscription: null,
        variation: null,
        obiettivi: [],
        allergeni: [],
        products: []
      };
      
      log('resetAbbonamento', abbonamento);
      context.commit('setStep', 0);
      context.commit('setStore', abbonamento);
      context.commit('destroy');
    }
  },
  getters: {
    allProducts: state => state.products,
    getNumberOfProducts: state => (state.products) ? state.products.length : 0,
    step(state) {
      return state.step;
    },
    abbonamento(state) {
      return state.abbonamento;
    },
    abbonamento_active(state) {
      return state.abbonamento.id;
    },
    subscription(state) {
      return state.abbonamento.subscription;
    },
    variation(state) {
      return state.abbonamento.variation;
    },
    obiettivi_active(state) {
      return state.abbonamento.obiettivi;
    },
    products_active(state) {
      return state.abbonamento.products;
    },
    allergeni_active(state) {
      return state.abbonamento.allergeni;
    },
    subscriptions(state) {
      return state.subscriptions;
    },
    variations(state) {
      return state.variations;
    },
    obiettivi(state) {
      return state.obiettivi;
    },
    allergeni(state) {
      return state.allergeni;
    },
    products(state) {
      return state.products;
    },
    backupProductsSelected(state) {
      return state.backupProductsSelected;
    }
  },
  modules: {},
  // plugins: [vuexLocalStorage.plugin]
});